import type { UnwrapNestedRefs } from "vue";
import request from "../../utils/request";
import cloneDeep from "lodash-es/cloneDeep";
import { ElDialog, ElMessage } from "element-plus";
import type { DialogProps } from "element-plus";
import { Top } from "@element-plus/icons-vue";
import QuickForm from "../../QuickForm/src";
import type { QuickFormPropsType } from "../../QuickForm/src";
import { buildProps } from "../../utils/props";
import "./style.scss";
import { VNode } from "vue-demi";
import { AddButtonRender, FetchCallBack, MethodMap, RowFuncMap, UrlMap } from "./type";
import type { AfterLoadDataSuccessType, BeforeChangeListFilterType, FetchDataFilterType, FetchFuncType, IsSuccessType, ResDataFilterType, RowRenderType, ShowLabelRenderType, TodoListStateType, TodoListType } from "./type";
import { defineComponent, h, onBeforeMount, onMounted, watch } from "vue";
import type { ComponentPublicInstance, ExtractPropTypes, PropType, SetupContext } from "vue";
import type { ElFormPropsType, FormDataStateType, FormRenderItemConfType, RenderNodesType, ResetFormInterface, SubmitFormInterface, ValidateInterface } from "../../QuickForm/src/types";
import { reactive } from "vue";
import type { Method } from "axios";
import lodash from "lodash-es";
import type { SubmitToSeverOperateType } from "quick-vue-components/commonMix/submitToServer/types";
import { Plus, Bottom, EditPen,Delete } from "@element-plus/icons-vue";
const TodoListProps = {
  ...buildProps({
    typeTitle: {
      type: String,
      default: "表单项",
    },
    className: {
      type: String,
      default: "",
    },
    showLabelRender: {
      type: Function as PropType<ShowLabelRenderType>,
      default: (row: any): VNode => row.label,
    },

    editRowDataFilter: {
      type: Function,
      default: (row: any): any => row,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    disabledMove: {
      type: Boolean,
      default: false,
    },
    disabledAdd: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Array,
      default: (): any[] => [],
    },
    editItemDataFilter: {
      type: Function,
      default: (v: any): any => v,
    },

    resetItemFormDataFilter: {
      type: Function,
      default: (v: any): any => v,
    },
    addButtonRender: {
      type:[Boolean , Function  as PropType<AddButtonRender>] ,
      default: false
    },

    urlMap: {
      type: Object as PropType<UrlMap>,
      default: (): UrlMap => ({
        get: "",
        add: "",
        edit: "",
        delete: "",
      }),
    },

    methodMap: {
      type: Object as PropType<MethodMap>,
      default: (): MethodMap => ({
        get: "post",
        add: "post",
        edit: "post",
        delete: "post",
      }),
    },

    fetchDataFilter: {
      type: Function as PropType<FetchDataFilterType>,
      default: (data: any, type: any) => data,
    },
    resDataFilter: {
      type: Function as PropType<ResDataFilterType>,
      default: (data: any, type: any) => data,
    },
    afterLoadDataSuccess: {
      type: Function as PropType<AfterLoadDataSuccessType>,
      default: (res: any) => res,
    },
    beforeChangeListFilter: {
      type: Function as PropType<BeforeChangeListFilterType>,
      default: (res: any) => res,
    },
    isSuccess: {
      type: Function as PropType<IsSuccessType>,
      default: (res: any) => res,
    },
    editFormRenderData: {
      type: Array  as PropType<FormRenderItemConfType<any>[]>, 
      default: ():FormRenderItemConfType<any>[] => [
        {
          type: "text",
          name: "label",
          layoutCol: 24,
          label: "标题",
          rules: [{ required: true }],
        },
        {
          type: "text",
          name: "value",
          layoutCol: 24,
          label: "值",
          rules: [{ required: true }],
        },
      ],
    },
    dialogProps: {
      type: Object as PropType<Partial<DialogProps>>,
      default: () => ({}),
    },
    formProps: {
      type: Object as PropType<Partial<ElFormPropsType>>,
      default: () => ({}),
    },
    editFormProps: {
      type: Object as PropType<Partial<QuickFormPropsType>>,
      default: () => ({}),
    },
    rowRender: {
      type: Function as PropType<RowRenderType>,
      default: (
        row: any,
        idx: number,
        value: any[],
        disabled: boolean,
        disabledMove: boolean,
        rowFuncMap: RowFuncMap
      ): VNode | VNode[] => {
        return [
          <el-tag
            style={{ margin: "0 10px 10px 0" }}
            key={row.id || idx}
            class="row-item"
          >
            <span style={{ marginRight: "25px" }}>
              {rowFuncMap.showLabelRender(row, idx)}
            </span>
            {disabled || disabledMove ? null : (
              <el-link
                size="small"
                type="primary"
                circle={true}
                style={{ marginRight: "10px" }}
                onClick={() => rowFuncMap.moveIdx(-1, idx, row)}
              >
                <el-icon size={14}>
                  <Top/>
                </el-icon>
              </el-link>
            )}
            {disabled || disabledMove ? null : (
              <el-link
                size="small"
                type="primary"
                circle={true}
                style={{ marginRight: "10px" }}
                onClick={() => rowFuncMap.moveIdx(1, idx, row)}
              >
                <el-icon size={14}>
                  <Bottom />
                </el-icon>
              </el-link>
            )}
            {disabled ? null : (
              <el-link
                size="small"
                type="primary"
                circle={true}
                style={{ marginRight: "10px" }}
                onClick={() => rowFuncMap.editFunc(idx, row)}
                icon="el-icon-edit"
              >
                <el-icon size={14}>
                  <EditPen />
                </el-icon>
              </el-link>
            )}
            {disabled ? null : (
              <el-link
                type="primary"
                circle={true}
                size="small"
                onClick={() => rowFuncMap.deleteFunc(idx, row)}
              >
                <el-icon size={14}>
                  <Delete />
                </el-icon>
              </el-link>
            )}
          </el-tag>,
        ];
      },
    },
  }),
};
export type TodoListPropsType = ExtractPropTypes<typeof TodoListProps>;
export default  defineComponent({
  name: "TodoList",
  components: { Plus,QuickForm},
  props: TodoListProps,
  setup(props: TodoListPropsType, ctx: SetupContext<any>): TodoListType {
    const state: UnwrapNestedRefs<TodoListStateType> = reactive({
      groupValue: lodash.cloneDeep(props.modelValue),
      editDialogVisible: false,
      editFormValue: {},
      editType: "add",
      editIdx: 0,
    });
    watch(state.groupValue,(newVal)=>{
      ctx.emit('update:modelValue',newVal)
    })
    watch(()=>props.modelValue,(newVal)=>{
      state.groupValue=newVal
    })
    onBeforeMount(() => {
      if (props.urlMap.get) {
        loadData(
          "get",
          props.urlMap.get,
          props.methodMap.get,
          {},
          (res: any) => {
            state.groupValue =
              res.data && lodash.isArray(res.data) ? res.data : [];
          }
        );
      }
    });
    function loadData(
      type: FetchFuncType,
      url: string,
      fetchType: Method,
      fetchData: any,
      cb: FetchCallBack
    ): void {
      console.log("loading.....");
      request({
        url: url,
        method: fetchType,
        [fetchType == "get" ? "params" : "data"]: props.fetchDataFilter
          ? props.fetchDataFilter(fetchData, type)
          : {},
      })
        .then((res: any) => {
          res = props.resDataFilter ? props.resDataFilter(res, type) : {};
          if (props.isSuccess && props.isSuccess(res, type)) {
            props.afterLoadDataSuccess && props.afterLoadDataSuccess(res, type);
            cb(res, type);
          }
        })
        .catch((err: any) => {
          console.log(err);
          const errMsg = err.message || err.msg;
          if (errMsg) {
            ElMessage.error(errMsg);
          }
        });
    }

    function createItem(): void {
      state.editDialogVisible = true;
      state.editFormValue =
        props.resetItemFormDataFilter && props.resetItemFormDataFilter({});
      state.editType = "add";
      console.log('add')
    }
    function editItem(idx: number, row: any): void {
      state.editDialogVisible = true;
      state.editFormValue =
        props.resetItemFormDataFilter &&
        props.resetItemFormDataFilter(lodash.cloneDeep(row));
      state.editType = "edit";
      state.editIdx = idx;
    }
    function deleteItem(idx: number, row: any): void {
      if (props.urlMap.delete) {
        loadData(
          "delete",
          props.urlMap.delete,
          props.methodMap.delete,
          row,
          () => {
            deleteSuccess(idx);
          }
        );
      } else {
        deleteSuccess(idx);
      }
    }
    function moveIdx(move = 1, idx: number, item: any): void {
      if (
        (move == 1 && idx >= state.groupValue.length - 1) ||
        (move == -1 && idx <= 0)
      ) {
        return;
      }
      const moveItem = state.groupValue[idx];
      state.groupValue.splice(idx, 1);
      state.groupValue.splice(idx + move, 0, moveItem);
    }
    // 增删改成功回调 start
    function resetEditStatus(): void {
      state.editDialogVisible = false;
      state.editFormValue = {};
    }
    function addSuccess(v: any): void {
      v = props.editRowDataFilter && props.editRowDataFilter(v);
      state.groupValue.push(v);
      ctx.emit("update:modalValue", state.groupValue);
      resetEditStatus();
    }
    function editSuccess(v: any): void {
      v = props.editRowDataFilter && props.editRowDataFilter(v);
      state.groupValue[state.editIdx] = v;
     
      ctx.emit("update:modalValue", state.groupValue);
      resetEditStatus();
    }
    function deleteSuccess(idx: number): void {
      state.groupValue.splice(idx, 1);
    }
    // 增删改成功回调 end
    function afterEditItemSuccess(v: any): void {
      v =
        props.editItemDataFilter &&
        props.editItemDataFilter(lodash.cloneDeep(v));

      if (state.editType == "add") {
        if (props.urlMap.add) {
          loadData("add", props.urlMap.add, props.methodMap.add, v, (res) => {
            addSuccess(
              props.beforeChangeListFilter &&
                props.beforeChangeListFilter(v, res, "add")
            );
          });
        } else {
          addSuccess(v);
        }
      } else {
        if (props.urlMap.edit) {
          loadData(
            "edit",
            props.urlMap.edit,
            props.methodMap.edit,
            v,
            (res) => {
              editSuccess(
                props.beforeChangeListFilter &&
                  props.beforeChangeListFilter(v, res, "edit")
              );
            }
          );
        } else {
          editSuccess(v);
        }
      }
    }
    function EditItemRender(): any {
      const formProps: Partial<ElFormPropsType> = {
        labelPosition: "right",
        labelWidth: "80px",
        ...props.formProps,
      };
      return (
        <el-dialog
          {...{
            modal: false,
            title:
              (state.editType == "add" ? "添加" : "编辑") + props.typeTitle,
            width: "600px",
            modelValue: state.editDialogVisible,
            ...props.dialogProps,

            "onUpdate:modelValue": ($event: boolean) => {
              state.editDialogVisible = $event;
            },
          }}
        >
          <QuickForm
            {...{
              formProps,
              propsData: {
                todoEditIdx: state.editType,
              },
              onSubmit: afterEditItemSuccess,
              modelValue: state.editFormValue,
              disabled: props.disabled,
              renderData: props.editFormRenderData,
              buttonGroupColConfig: {
                span: 24,
                style: {
                  "text-align": "center",
                  margin: "20px 0 0",
                },
              },
              buttonGroupRender: (
                modelValue: any,
                submitFunc: SubmitFormInterface,
                
              ): RenderNodesType => { 
                return <div>
                  {props.disabled ? null : (
                    <el-button type="primary" onClick={submitFunc}>
                      提交
                    </el-button>
                  )}
                  <el-button onClick={() => (state.editDialogVisible = false)}>
                    关闭
                  </el-button>
                </div>
              },
              ...props.editFormProps,
            }}
          />
        </el-dialog>
      );
    }
    return {
      state,
      createItem,
      editItem,
      deleteItem,
      moveIdx,
      EditItemRender,
    };
  },

  render(_ctx: ComponentPublicInstance<TodoListPropsType,TodoListType> ) {
  // const { groupValue, className, rowRender } = this;

    return (
      <div class={"comp-todolist-wrap " + _ctx.$props.className}>
        {_ctx.EditItemRender()}
        <div class="comp-todolist-btnGroup">
          {_ctx.$props.disabled || _ctx.$props.disabledAdd ? null : lodash.isFunction(_ctx.$props.addButtonRender) ? (
            _ctx.$props.addButtonRender(_ctx)
          ) : (
            <el-button
              type="primary"
              size="small"
            
              onClick={() => _ctx.createItem()}
            
            >新增</el-button>
         
          )}
        </div>
        <div class="comp-todolist-listGroup">
          {_ctx.state.groupValue.map((item:any, idx:number) =>
            _ctx.$slots.default
              ? _ctx.$slots.default({
                  item,
                  idx,
                  groupValue:_ctx.state.groupValue,
                  createItem: _ctx.createItem,
                  editItem: _ctx.editItem,
                  deleteItem: _ctx.deleteItem,
                  moveIdx: _ctx.moveIdx,
                  disabled: _ctx.disabled,
                })
              : _ctx.$props.rowRender(
                  item,
                  idx,
                  _ctx.state.groupValue,
                  _ctx.$props.disabled,
                  _ctx.$props.disabledMove,
                  {
                    showLabelRender: _ctx.$props.showLabelRender,
                    createFunc: _ctx.createItem,
                    editFunc:_ctx.editItem,
                    deleteFunc:_ctx.deleteItem,
                    moveIdx:_ctx.moveIdx,
                    
                  }
                   
                )
          )}
        </div>
      </div>
    );
  },
});
